import React from 'react';
import styled from 'styled-components';
import { Translation } from '~/components/Translation';
import Text from '~/components/Text';

const FeatureCardContainer = styled.div`
	display: flex;
	width: 350px;
	flex-direction: column;
	align-items: flex-start;
	border-radius: 16px;
	box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.05);

	@media (max-width: 500px) {
		max-width: 350px;
		width: 100%;
	}
`;

const IconContainer = styled.div`
	display: flex;
	padding: 28px 0 0 24px;
	align-items: center;
`;

const Icon = styled.img`
	width: 48px;
	height: 48px;
`;

const TextContainer = styled.div`
	display: flex;
	padding: 28px;
	flex-direction: column;
	align-items: flex-start;
	gap: 12px;
	align-self: stretch;
`;

const FeatureTitle = styled(Text)`
	font-size: 20px;
	font-weight: 600;
	line-height: 1.3;
`;

const FeatureDescription = styled(Text)`
	color: ${({ theme }) =>
		theme.tokens.COLOR_TOKENS_TEXT_INVERTIBLE_NEUTRAL_NEUTRAL_STRONG};
	font-size: 14px;
	line-height: 1.5;
`;

interface FeatureCardProps {
	iconSrc: string;
	titleKey: string;
	descriptionKey: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
	iconSrc,
	titleKey,
	descriptionKey,
}) => {
	return (
		<FeatureCardContainer>
			<IconContainer>
				<Icon src={iconSrc} alt="" />
			</IconContainer>
			<TextContainer>
				<FeatureTitle variant="h4">
					<Translation tid={titleKey} />
				</FeatureTitle>
				<FeatureDescription variant="body">
					<Translation tid={descriptionKey} />
				</FeatureDescription>
			</TextContainer>
		</FeatureCardContainer>
	);
};

export default FeatureCard;
